// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"485":"6f1abf8f","940":"8dd7db53"}[chunkId] + ".chunk.css";
};